module.exports = __webpack_public_path__ + "img/opef_med_bleu.6dc04d86.png";